import {ProjectFeatureFlag, ReportName} from 'common/report/constants';
import {ProjectDetails} from 'common/report/stores/project-details';

import {getReportUrl} from './index';

export function isBoardsUiEnabled(project: ProjectDetails) {
  /**
   * why do we pass in project details every time even though we can just call the store here?
   * components that rely on stores usually also have to subscribe to store updates, if they don't we might run into race conditions, such
   * as not displaying the right thing until it loads. if we put the loaded store's value, now we guarantee we're looking at the right thing, and handle
   * store waiting in the handler
   *
   */
  return project?.hasFeatureFlag(ProjectFeatureFlag.BoardsUi);
}

export function getBookmarkInDashboardHref({
  dashboardId,
  bookmarkId,
  projectId,
  workspaceId,
}: {
  dashboardId: number;
  bookmarkId: number;
  projectId: number;
  workspaceId: number;
}) {
  const base = getReportUrl(`dashboards`, {
    projectId,
    workspaceId,
  });
  const hashParams = [];
  if (dashboardId) {
    hashParams.push(`id=${dashboardId}`);
  }
  if (bookmarkId) {
    hashParams.push(`focused-bookmark-id=${bookmarkId}`);
  }
  return hashParams.length ? `${base}#${hashParams.join(`&`)}` : base;
}

export const REPORT_ICONS = {
  [ReportName.Insights]: `brand-insights`,
  [ReportName.Funnels]: `brand-funnels`,
  [ReportName.Flows]: `brand-flows`,
  [ReportName.Retention]: `brand-retention`,
  [ReportName.Dashboards]: `brand-dashboard`,
};
